import { Link, useLocation } from "react-router-dom";
import bg from "assets/www/intro_bg.jpg";
import logo from "assets/logo/intro_logo.png";
import air from "assets/www/air_white.png";
import morning from "assets/www/morning_white.png";
import quick from "assets/www/quick_white.png";
import express from "assets/www/express_white.png";
import arrow from "assets/www/arr_right_white.png";
import { RouteTypes } from "hooks/utils/util";
import Seo from "components/Seo";

export const introPages = [
    // "/www.ilshingroup.com",
    // "/ilshingroup.com",
];

type SiteProps = {
    title: string;
    description: string;
    link: RouteTypes;
    image: {
        src: string;
        width: number;
        background: string;
    };
}[];

const SITES: SiteProps = [
    {
        title: "일신항공해운",
        description: "PREMIUM AIR&SEA SERVICE",
        link: "air",
        image: {
            src: air,
            width: 34,
            background: "#20b6e5",
        },
    },
    {
        title: "일신모닝택배",
        description: "PREMIUM MORNING SERVICE",
        link: "morning",
        image: {
            src: morning,
            width: 42,
            background: "#fdaf1b",
        },
    },
    {
        title: "일신모닝퀵",
        description: "PREMIUM QUICK SERVICE",
        link: "quick",
        image: {
            src: quick,
            width: 34,
            background: "#20b6e5",
        },
    },
    {
        title: "일신특송화물",
        description: "PPREMIUM EXPRESS SERVICE",
        link: "express",
        image: {
            src: express,
            width: 40,
            background: "#27c1c1",
        },
    },
];

export default function Intro({ changeSubdomain }: { changeSubdomain: (subdomain: RouteTypes) => void }) {
    const location = useLocation();
    const currentPath = location.pathname;
    return (
        <>
            <Seo type="www" />
            <div
                className="min-h-[100dvh] max-w-[1024px] min-w-[320px] w-full mx-auto bg-cover bg-bottom"
                style={{ backgroundImage: `url(${bg})` }}
            >
                <header className="flex justify-center py-[35px]">
                    <h1>
                        <Link to={currentPath}>
                            <span className="sr-only">일신그룹 - 국내외 물류 전문 일신그룹</span>
                            <img src={logo} alt="일신그룹" />
                        </Link>
                    </h1>
                </header>

                <section className="px-11 pt-[10px] pb-[30px]">
                    <ul className="">
                        {SITES.map((item, index) => {
                            return (
                                <li
                                    key={index}
                                    className="text-white flex justify-between items-center py-[25px] border-b border-white/30 cursor-pointer "
                                    onClick={() => {
                                        changeSubdomain(item.link);
                                    }}
                                >
                                    <div className="flex gap-4 flex-1">
                                        <figure
                                            style={{ backgroundColor: item.image.background }}
                                            className="w-[70px] h-[70px] rounded-full flex items-center justify-center"
                                        >
                                            <img src={item.image.src} alt={item.title} width={item.image.width} />
                                        </figure>

                                        <div>
                                            <div className="text-[12px] leading-[20px] font-[100]">{item.description}</div>
                                            <div className="font-bold text-[26px] leading-[32px] pt-[5px]">{item.title}</div>
                                        </div>
                                    </div>

                                    <img src={arrow} alt="" width={13} height={23} />
                                </li>
                            );
                        })}
                    </ul>
                </section>
                <div className="text-center text-white py-[25px] text-[14px]">
                    Copyright ⓒ 2020 (주)일신그룹 All right reserved.
                    <iframe name="process" width="0" height="0"></iframe>
                </div>
            </div>
        </>
    );
}
